<div class="growth-charts-tab-data-type-container">
    <div class="datos-oms" [ngClass]="omsDataColor">
        {{omsDataText | translate:locale.language}}
    </div>
</div>